import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {TextModalComponent} from "../../modal/text-modal/text-modal.component";


@Component({
    selector: 'app-leaf-impact-score',
    templateUrl: './leaf-impact-score.component.html',
    styleUrls: ['./leaf-impact-score.component.scss'],
    standalone: false
})
export class LeafImpactScoreComponent implements OnInit {
  @Input() globalAP: number;
  @Input() globalValue: string;
  @Input() globalAdopts: number;
  @Input() globalAvg: string;
  @Input() myAP: number;
  @Input() myValue: string;
  @Input() myAdopts: number;
  @Input() label: string;
  @Input() icon: string;

  private statisticsModalElement?: any;
  private impactscoreModalElement?: any;

  constructor(
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
  }

  async statisticsModal() {
    this.statisticsModalElement = await this.modalController.create({
      component: TextModalComponent,
      componentProps: {
        type: 'statistics'
      },
      backdropDismiss: true,
      mode: 'ios',
      id: 'generalModal'
    });
    await this.statisticsModalElement.present();

    await this.statisticsModalElement.onDidDismiss().then(res => {

    });
    return;
  }

  async impactscoremodal() {
    this.impactscoreModalElement = await this.modalController.create({
      component: TextModalComponent,
      componentProps: {
        type: 'impact'
      },
      backdropDismiss: true,
      mode: 'ios',
      id: 'generalModal'
    });
    await this.impactscoreModalElement.present();

    await this.impactscoreModalElement.onDidDismiss().then(res => {

    });
    return;
  }

}
